import styled from "styled-components";

import microphone from "img/microphone.svg";
import refreshBG from "img/refreshBG.svg";

export const StyledHeader = styled.header`
  width: 100%;
  padding-top: 40px;
`;

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 1440px;
  padding: 0 90px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  @media (max-width: 1180px) {
    padding: 0 20px;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 675px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  margin-top: 20px;
  max-width: 450px;
  flex-wrap: wrap;
  justify-content: flex-start;
  @media (max-width: 1024px) {
    width: 600px;
    justify-content: flex-start;
  }
  @media (max-width: 675px) {
    width: 90vw;
    align-items: center;
    flex-wrap: wrap;
  }
`;

export const RefreshButton = styled.button`
  width: ${({ theme }) => theme.size};
  height: ${({ theme }) => theme.size};
  border-radius: 5px;
  background-color: ${({ theme }) => theme.COMMON};
  background-image: url(${refreshBG});
  background-position: center center;
  background-size: cover;
  border: none;
  transition-duration: 0.5s;
  &:focus {
    outline: none;
  }
  &:hover {
    transform: scale(0.9);
    cursor: pointer;
  }
`;

export const Input = styled.input`
  box-sizing: border-box;
  height: ${({ theme }) => theme.size};
  width: 300px;
  background-color: ${({ theme }) => theme.DARKLY};
  font-family: ${({ theme }) => theme.fonts};
  color: ${({ theme }) => theme.WHITE};
  padding-left: 10px;
  border-width: 2px;
  border-style: inset;
  border-color: rgb(118, 118, 118);
  border-image: initial;
  border-right: none;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${({ theme }) => theme.WHITE};
  }
  @media (max-width: 1024px) {
    width: 600px;
  }
  @media (max-width: 675px) {
    width: 78vw;
  }
  @media (max-width: 375px) {
    width: 70vw;
  }
`;

export const MicrophoneImg = styled.svg`
  box-sizing: border-box;
  height: ${({ theme }) => theme.size};
  width: ${({ theme }) => theme.size};
  background-color: ${({ theme }) => theme.DARKLY};
  background-image: url(${microphone});
  background-repeat: no-repeat;
  background-position: center center;
  border-width: 2px;
  border-style: inset;
  border-color: rgb(118, 118, 118);
  border-image: initial;
  border-left: none;
  transition-duration: 0.5s;
  color: white;
  &:hover {
    background-size: 18px auto;
    cursor: pointer;
  }
`;

export const SearchButton = styled.button`
  width: 100px;
  height: ${({ theme }) => theme.size};
  border-radius: 5px;
  border: none;
  background-color: ${({ theme }) => theme.COMMON};
  color: ${({ theme }) => theme.WHITE};
  font-family: ${({ theme }) => theme.fonts};
  font-style: normal;
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  transition-duration: 0.5s;
  &:focus {
    outline: none;
  }
  &:hover {
    transform: scale(0.9);
    cursor: pointer;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Info = styled.p`
  height: 25px;
  font-size: 24px;
  color: red;
  padding: 0;
  margin: 0;
  margin-left: 10px;
  display: ${({ error }) => (error ? "block" : "none")};
`;
